var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgFullLinkedInImg = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43.097,
    height: 11.492,
    viewBox: "0 0 43.097 11.492",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g3019",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14",
    d: "M243.837-101.464a.851.851,0,0,1,.876-.823h10.1a.851.851,0,0,1,.876.823v9.846a.851.851,0,0,1-.876.823h-10.1a.851.851,0,0,1-.876-.823Z",
    transform: "translate(-212.596 102.287)",
    fill: "#0a66c2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path16",
    d: "M31.738-81.023h4.948v-1.533H33.529v-5.85H31.738Z",
    transform: "translate(-31.738 90.578)",
    fill: "#0a66c2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path18",
    d: "M69.143-81.9v-5.091H67.352V-81.9Zm-.9-5.787a.913.913,0,0,0,1.013-.88.909.909,0,0,0-1-.879.913.913,0,0,0-1.013.879.905.905,0,0,0,.99.88h.012Z",
    transform: "translate(-61.69 91.456)",
    fill: "#0a66c2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path20",
    d: "M84.68-68.143h1.791v-3.009a1.226,1.226,0,0,1,.059-.437.98.98,0,0,1,.919-.655c.648,0,.907.494.907,1.218v2.882h1.791v-3.089c0-1.655-.884-2.425-2.062-2.425a1.784,1.784,0,0,0-1.626.908h.012v-.781H84.68c.024.506,0,5.387,0,5.387Z",
    transform: "translate(-76.804 77.831)",
    fill: "#0a66c2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path22",
    d: "M126.1-88.406h-1.791v7.383H126.1v-1.649l.448-.532,1.4,2.18h2.2L127.8-84.179l2.062-2.148h-2.156s-1.473,1.922-1.6,2.149Z",
    transform: "translate(-110.547 90.578)",
    fill: "#0a66c2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path24",
    d: "M163.046-71.7a4.385,4.385,0,0,0,.059-.7,2.516,2.516,0,0,0-2.568-2.807,2.852,2.852,0,0,0-2.91,3c0,1.766,1.119,2.87,3.075,2.87a5.568,5.568,0,0,0,2.085-.356l-.236-1.183a4.872,4.872,0,0,1-1.59.24c-.836,0-1.567-.343-1.626-1.075l3.711.011Zm-3.723-1.211a1.169,1.169,0,0,1,1.119-1.138,1.025,1.025,0,0,1,1,1.138Z",
    transform: "translate(-138.898 79.113)",
    fill: "#0a66c2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path26",
    d: "M198.655-88.406v2.558h-.024a1.838,1.838,0,0,0-1.52-.6,2.6,2.6,0,0,0-2.58,2.823,2.512,2.512,0,0,0,2.462,2.725,2.059,2.059,0,0,0,1.8-.891h.035l.071.771h1.591c-.024-.358-.047-.977-.047-1.585v-5.8Zm0,5.034a1.792,1.792,0,0,1-.035.369,1.043,1.043,0,0,1-1.048.793c-.742,0-1.225-.565-1.225-1.455,0-.836.412-1.509,1.237-1.509a1.045,1.045,0,0,1,1.049.8,1.328,1.328,0,0,1,.024.3Z",
    transform: "translate(-170.328 90.578)",
    fill: "#0a66c2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path28",
    d: "M256.58-81.942v-5.092h-1.791v5.092Zm-.9-5.787a.913.913,0,0,0,1.013-.88.909.909,0,0,0-1-.88.914.914,0,0,0-1.013.88.905.905,0,0,0,.99.88h.012Z",
    transform: "translate(-221.377 91.491)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path30",
    d: "M273.136-68.184h1.791v-3.009a1.227,1.227,0,0,1,.059-.437.98.98,0,0,1,.919-.655c.648,0,.907.494.907,1.218v2.882H278.6v-3.089c0-1.655-.883-2.425-2.062-2.425a1.784,1.784,0,0,0-1.626.908h.012v-.781h-1.791c.023.506,0,5.388,0,5.388Z",
    transform: "translate(-237.311 77.866)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFullLinkedInImg, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/fullLinkedInImg.fabf3325.svg";
export { ForwardRef as ReactComponent };